import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import '../css/Navbar.css';
// import logo from '../../images/logo.png';

const Navbar = () => {
    // Inside your component
    const navigate = useNavigate();

    const handleFeaturesClick = (e) => {
        e.preventDefault(); // prevent default href behavior
        navigate('/features'); // navigate programmatically
    };
    return (
        <nav className="navbar navbar-expand-lg custom-navbar sticky-top px-4 shadow">
            <div className="container-fluid">
                <NavLink className="navbar-brand" to="/">
                    {/* <img src={logo} alt="Logo" height="60" /> */}
                   <h3><b> <span className="highlight-button">The Black Stone</span> </b></h3> 
                </NavLink>

                <button
                    className="navbar-toggler"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#navbarNav"
                    aria-controls="navbarNav"
                    aria-expanded="false"
                    aria-label="Toggle navigation"
                >
                    <span className="navbar-toggler-icon"></span>
                </button>

                <div className="collapse navbar-collapse" id="navbarNav">
                    <ul className="navbar-nav ms-auto align-items-center">
                        <li className="nav-item ms-4">
                            <NavLink className="nav-link" to="/">Home</NavLink>
                        </li>
                        <li className="nav-item ms-4">
                            <NavLink className="nav-link" to="/about">About</NavLink>
                        </li>
                        {/* <li className="nav-item ms-4">
                             <NavLink className="nav-link" to="/services">Services</NavLink>
                        </li> */}
                        {/* <li className="nav-item ms-4">
                             <NavLink className="nav-link" to="/features">Features</NavLink>
                        </li> */}
                        <li className="nav-item ms-4">
                             <NavLink className="nav-link" to="/faq">FAQs</NavLink>
                        </li>

                        {/* <li className="nav-item dropdown ms-4">
                            <a
                                className="nav-link dropdown-toggle"
                                href="/features"
                                role="button"
                                data-bs-toggle="dropdown"
                                aria-expanded="false"
                                onClick={handleFeaturesClick}
                            >
                                Feature
                            </a>
                            <ul className="dropdown-menu">
                                <li><NavLink className="dropdown-item" to="/features">Feature</NavLink></li>
                                <li><NavLink className="dropdown-item" to="/faq">FAQs</NavLink></li>
                            </ul>
                        </li> */}

                        {/* <li className="nav-item ms-4">
                             <NavLink className="nav-link" to="/contact-us">Contact Us</NavLink>
                        </li> */}

                        <li className="nav-item ms-4">
                            <NavLink
                                className="btn book-call-btn nav-link"
                                to="/login"
                            >
                                Login / Register
                            </NavLink>
                        </li>
                        
                        
                    </ul>
                    {/* 👉 Add this below the <ul> list */}
                    {/* <div className="d-lg-none mt-3 text-center">
                        <a href="mailto:blackstone19750@gmail.com" className="btn btn-outline-primary me-2 mb-2 w-75">
                            📧 blackstone19750@gmail.com
                        </a>
                        <a href="tel:" className="btn btn-outline-success w-75">
                            📞 Call Us
                        </a>
                    </div> */}
                </div>
            </div>
        </nav>
    );
};

export default Navbar;
